import { MuiTypography } from '@/features/shared/material-ui';
import React, { forwardRef } from 'react';

export const TabbedCardTab = forwardRef((props: any, ref: any) => {
  const { children, title, tabIndex, theme, ...tabProps } = props;

  return (
    <div {...tabProps} ref={ref}>
      <MuiTypography className="heading" variant="body1" component="h3">
        {title?.text}
      </MuiTypography>
    </div>
  );
});
